import React, { createContext, useEffect, useState } from 'react';

export const ConfigContext = createContext();

export const ConfigProvider = ({ children }) => {
  const [apiURL] = useState('https://adminapis.royalbakery.co.in/');
  const [token, setToken] = useState(localStorage.getItem("token"));
  const [user_id] = useState(localStorage.getItem("user_id"));
  const [apiHeaderJson] = useState({ 'Content-Type': "application/json", token: `${token}`, 'user_id': user_id, 'user-id': user_id })
  const [apiHeaderFile] = useState({ 'Content-Type': "multipart/form-data", token: `${token}`, 'user_id': user_id, 'user-id': user_id })
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear().toString());
  const [selectedMonth, setSelectedMonth] = useState((new Date().getMonth() + 1).toString());
  const primaryColor = '#2a3266';

  const handleUpdateLogin = (data) => {
    setToken(data.token);
    localStorage.setItem('token', data.token);
    localStorage.setItem('user_id', data.user_id);
  }


  const selectTheme = (theme) => ({
    ...theme,
    colors: {
      ...theme.colors,
      primary: "#2a3266",
    },
  });

  const selectStyle = {
    control: (styles, state) => {
      return {
        ...styles,
        backgroundColor: "#fff",
      };
    },
  };

  const statusOptions = [
    { value: 1, label: 'Approve' },
    { value: 2, label: 'Reject' }
  ];


  var vals = {
    apiURL,
    token,
    apiHeaderJson,
    apiHeaderFile,
    handleUpdateLogin,
    selectedYear,
    selectedMonth,
    setSelectedYear,
    setSelectedMonth,
    primaryColor,
    selectStyle,
    selectTheme,
    user_id,
    statusOptions
  };

  return (
    <ConfigContext.Provider value={vals}>
      {children}
    </ConfigContext.Provider>
  );
};
